import React from "react";
import WidgetContainer from "../WidgetContainer.jsx";
import pandaImg from "../../../../../assets/panda_stakeholders.png";
import TaskEnergyAnalyzer from "../Module5/TaskEnergyAnalyzer.jsx";
import ClassifyTasks from "../Module5/ClassifyTasks.jsx";
import ClassifyBuckets from "../Module5/ClassifyBuckets.jsx";
import DelegationFramework from "../Module5/DelegationFramework.jsx";
import DelegationPlacement from "../Module5/DelegationPlacement.jsx";
import DelegationAssignment from "../Module5/DelegationAssignment.jsx";
import DelegationBlocker from "../Module5/DelegationBlocker.jsx";
import CelebrationScreen from "../Module5/CelebrationScreen.jsx";
import FinalSummary from "../Module5/FinalSummary.jsx";

const EnergyExpenditureAudit = ({
  userId,
  subsectionId,
  onComplete,
  onPhaseChange,
}) => {
  return (
    <WidgetContainer
      userId={userId}
      subsectionId={subsectionId}
      onComplete={onComplete}
      onPhaseChange={onPhaseChange}
      intro={{
        image: pandaImg,
        title: "Energy Expenditure Audit",
        description:
          "Are you spending your energy in the right place? Find out how to maximise returns.",
        buttonLabel: "Get Started",
      }}
      steps={[
        {
          id: "builder",
          title: "Analyze your Tasks vs Energy",
          component: TaskEnergyAnalyzer,
        },
        {
          id: "classify",
          title: "Classify Your Tasks",
          component: ClassifyTasks,
        },
        {
          id: "buckets",
          title: "Classify Your Tasks",
          description:
            "Most professionals are busy all day. Very few are working on what truly matters. Classify your tasks to see where your energy is utilized. This framework helps you spot the difference quickly.",
          component: ClassifyBuckets,
        },
        {
          id: "delegation",
          title: "Delegation Framework",
          component: DelegationFramework,
        },
        {
          id: "placement",
          title: "Delegation Framework",
          description:
            "Sort these tasks by impact and by who would be best suited to do them.",
          component: DelegationPlacement,
        },
        {
          id: "assignment",
          title: "Delegation Assignment",
          description:
            "Assign team members to the tasks you've identified for delegation.",
          component: DelegationAssignment,
        },
        {
          id: "blocker",
          title: "Delegation Blockers",
          description:
            "Identify what's blocking delegation for neutral and overhead tasks.",
          component: DelegationBlocker,
        },
        {
          id: "celebration",
          // title: "Celebration",
          component: CelebrationScreen,
          fullScreen: true,
        },
        {
          id: "summary",
          // title: "Final Summary",
          component: FinalSummary,
          fullScreen: true,
        },
      ]}
    />
  );
};

export default EnergyExpenditureAudit;
